import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SalesDashboard from './SalesDashboard';
import SalesTransactions from './SalesTransactions';
import InvoiceArchive from './InvoiceArchive';
import ReturnManagement from './ReturnManagement';
import DailySalesClosing from './DailySalesClosing';
import ProductSalesAnalytics from './ProductSalesAnalytics';
import DirectReturn from './DirectReturn';

const SalesOverview = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('dashboard');

    const tabs = [
        { id: 'dashboard',        label: t('Sales Dashboard'),        component: <SalesDashboard /> },
        { id: 'transactions',     label: t('Sales Transactions'),      component: <SalesTransactions /> },
        { id: 'archive',          label: t('Invoice Archive'),         component: <InvoiceArchive /> },
        { id: 'returns',          label: t('Return Management'),       component: <ReturnManagement /> },
        { id: 'direct_returns',   label: t('Direct Product Return'),   component: <DirectReturn /> },
        { id: 'daily_closing',    label: t('Daily Sales Report'),      component: <DailySalesClosing isEndOfDay={false} /> },
        { id: 'eod_closing',      label: t('End of Day Closing'),      component: <DailySalesClosing isEndOfDay={true} /> },
        { id: 'product_analytics',label: t('Product Sales Analytics'), component: <ProductSalesAnalytics /> },
    ];

    return (
        <div className="space-y-5">
            {/* Page header */}
            <div className="erp-page-header">
                <h1 className="erp-page-title">{t('Sales Overview')}</h1>
                <p className="erp-page-subtitle">{t('Manage all sales operations from one place')}</p>
            </div>

            {/* Tab bar */}
            <div className="erp-tab-bar">
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`erp-tab${activeTab === tab.id ? ' active' : ''}`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Tab content */}
            <div>
                {tabs.find(tab => tab.id === activeTab)?.component}
            </div>
        </div>
    );
};

export default SalesOverview;
